import { render } from "./EmailTemplates.vue?vue&type=template&id=ae911586&scoped=true&ts=true"
import script from "./EmailTemplates.vue?vue&type=script&lang=ts"
export * from "./EmailTemplates.vue?vue&type=script&lang=ts"

import "./EmailTemplates.vue?vue&type=style&index=0&id=ae911586&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae911586"]])

export default __exports__